export default "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAYAAAAfFcSJAAAADUlEQVR42mP8+fN3PQAJTgNui3zM0gAAAABJRU5ErkJggg=="